import {IController, IModule} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";

const css = require('./sikkerhetsinnstillinger.scss');

export class GruppeSikkerhetsinnstillingerKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
            .component('wmGruppeSikkerhetsinnstillinger', {
                bindings: {gruppe: "<"},
                controller: GruppeSikkerhetsinnstillingerKontroller.forInjisering(),
                template: require('./sikkerhetsinnstillinger.html')
            });
    }

    static forInjisering() {
        return [
            GruppeSikkerhetsinnstillingerKontroller
        ]
    }

    constructor() {
    }

    gruppe: l.GruppeModell; //settes via bindings/$onChanges

}
